import React from "react";
import "./topbar.css";

export default function Topbar() {

    return (
        <header className="topbar">
            <div className="topbar-container">
                {/* Logo / Title */}
                <h1 className="topbar-title">HLL Strategist</h1>
            </div>
        </header>
    );
}
